// Core Imports
import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'

// Module Imports
import { roleEndpoints } from '@/modules/role/role.constants'
import type {
  TCreateRoleRequest,
  TEditRoleRequest,
  TPermission,
  TRole,
} from '@/modules/role/role.types'

export async function getAllPermissions(): Promise<TPermission[]> {
  const response = await api.get<TResponse<TPermission[]>>(
    roleEndpoints.allPermissions
  )

  return response.data.data
}

export async function getRoleList(): Promise<TRole[]> {
  const response = await api.get<TResponse<TRole[]>>(roleEndpoints.list)
  return response.data.data
}

export async function getRoleDetail(id: string): Promise<TRole> {
  const response = await api.get<TResponse<TRole>>(roleEndpoints.detail(id))

  return response.data.data
}

export async function createRole(payload: TCreateRoleRequest): Promise<TRole> {
  const response = await api.post<TResponse<TRole>>(
    roleEndpoints.create,
    payload
  )

  return response.data.data
}

export async function editRole(payload: TEditRoleRequest): Promise<TRole> {
  const { id, ...requestBody } = payload
  const response = await api.put<TResponse<TRole>>(
    roleEndpoints.update(id),
    requestBody
  )

  return response.data.data
}

export async function deleteRole(id: string): Promise<string> {
  const response = await api.delete<string>(roleEndpoints.delete(id))

  return response.data
}
